export default __webpack_public_path__ + "static/media/why_allina_01.a453be6f.png";